export default __webpack_public_path__ + "static/media/buy-a-car.9c633d1c.svg";